import { useCallback } from 'react';
import { TextField} from '@mui/material';

import { useStepValidator } from 'Hooks/useStepValidator';
import { INPUT_STEP_NAMES } from 'Pages/Inputs/constants';
import { useInputStore } from 'Store';

export const NCows = () => {
  const n_cows = useInputStore(state => state.n_cows)
  const setValue = useInputStore((state) => state.set_value)

  // validation
  const isValidNumber = useCallback(() => {
    const number = Number(n_cows)

    // is it a valid number
    if (isNaN(number)) return false
    
    // is it a positive whole integer
    return Number.isInteger(number) && number >= 0
  }, [n_cows])

  useStepValidator(INPUT_STEP_NAMES.numbers, 'n_cows', () => isValidNumber(n_cows))

  return (
    <TextField
      size='small'
      type='number' 
      label='Number of Cows'
      value={n_cows}
      onChange={event => setValue({'n_cows': parseFloat(event.target.value)})}
      error={!isValidNumber()}
      helperText={!isValidNumber() ? 'Please enter a valid number. This cannot be less than 0 and must be a whole number.' : ''}
    />
  )
}
